if (!global._babelPolyfill) {
  require('babel-polyfill');
}

require('es6-promise').polyfill();



// WEBPACK FOOTER //
// ./~/public-sdk/src/public-sdk.js